/*******************
 * Profile events  *
 *******************/

$('body').on('click', '#reset-password-button', function (e) {
    $('#reset-password-form').submit();
});

$('body').on('click', '.nav-link', function () {
    profile.clearValidationFeedback();
});

$('body').on('click', '#company-add-employee-cancel', function () {
    profile.loadEmployeesOverview();
});

$('body').on('click', '#company-add-employee-submit', function () {
    iris.setButtonLoading($('#company-add-employee-submit'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'POST',
        url: '/profile/employees',
        data: $('form#add-employee').serialize(),
        success: function (response) {
            $('#tab-company-users').html(response);
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#company-add-employee-submit'));
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

$('body').on('input', '#add-employee-first-name', function () {
    profile.updateUsernameSuggestion();
});

$('body').on('input', '#add-employee-last-name', function () {
    profile.updateUsernameSuggestion();
});

$('body').on('focusin', '#add-employee-username', function () {
    iris.usernameChangedManually = true;
});

$('body').on('focusout', '#add-employee-username', function () {
    if ($('#add-employee-username').val() === '') {
        iris.usernameChangedManually = false;
    }
});

$('body').on('click', '#download-invoice', function (e) {
    e.preventDefault();

    var customerName = $(this).data('customer-name');
    var customerId = $(this).data('customer-id');

    $('.download-invoice input[name=customerName]').val(customerName);
    $('.download-invoice input[name=odinAccountId]').val(customerId);
    $(".download-invoice").modal('show');
});

$('body').on('click', '.download-invoice-button', function (e) {
    e.preventDefault();
    profile.clearValidationFeedback();

    let odinAccountId = $('.download-invoice form[name=downloadInvoice] input[name=odinAccountId]').val();
    let invoiceId = $('.download-invoice form[name=downloadInvoice] input[name=invoiceId]').val();

    $.ajax({
        method: 'GET',
        url: '/profile/downloadInvoiceCsv?odinAccountId=' + odinAccountId + '&invoiceId=' + invoiceId,
        success: function (response) {
            iris.unsetButtonLoading($('.download-invoice-button'));

            // this invoice has been retrieved correctly, so this response can be passed directly to the user
            location.href = '/profile/downloadInvoiceCsv?odinAccountId=' + odinAccountId + '&invoiceId=' + invoiceId;
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('.download-invoice-button'));
            profile.handleAjaxErrorResponse(response, status, error, undefined, '#download-invoice-dialog-ajax-validation');
        }
    });
});

$('body').on('click', '#company-add-new-employee', function () {
    iris.setButtonLoading($('#company-add-new-employee'));

    $.ajax({
        method: 'GET',
        url: '/profile/employees/create',
        success: function (response) {
            $('#tab-company-users').html(response);

            $('form#add-employee .moduleRoles').multiSelect({
                selectableHeader: '<div class="selectableHeader">Unassigned Roles</div>',
                selectionHeader: '<div class="selectionHeader">Assigned Roles</div>'
            });

            $('form#add-employee .moduleRoles').prop('disabled', true);
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#company-add-new-employee'));
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

$('body').on('click', '#company-add-employee-cancel', function () {
    iris.setButtonLoading($('#company-add-employee-cancel'));

    $.ajax({
        method: 'GET',
        url: '/profile/employees',
        success: function (response) {
            $('#tab-company-users').html(response);
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#company-add-employee-cancel'));
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

$('body').on('click', '#company-employee-close', function () {
    $('.nav-tabs a[href="#company"]').trigger('click');
    $('#company-user-nav-item').css('visibility', 'hidden');
});

$('body').on('click', '.nav-link', function () {
    if ($(this).data('nav-type') === 'top') {
        if ($(this).attr('id') !== 'user') {
            $('#company-user-nav-item').css('visibility', 'hidden');
        }
    }
});

$('body').on('click', '#company-add-location', function () {
    var omnitrackerId = $(this).data('ot-id');

    iris.setButtonLoading($('#company-add-location'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'POST',
        url: '/profile/companies/' + omnitrackerId + '/locations',
        data: $('form#companyLocation').serialize(),
        success: function (response) {
            var validationPlaceHolder = $('#ajax-validation');
            if (response.success) {
                // re-populate the locations select elements
                $('.companyLocations').each(function (index) {
                    var locationsSelect = $(this);
                    var selectedOption;

                    if ($(this).has('option:selected')) {
                        selectedOption = $(this).val();
                    }

                    locationsSelect.empty();
                    $.each(response.locations, function (index, location) {
                        var locationText = location.Street + ', ' + location.PostalCodeStreet + ' ' + location.City + ', ' + location.Country.TitleMultilingual;
                        if (location.ID == selectedOption) {
                            locationsSelect.append($('<option />').val(location.ID).text(locationText).attr('selected', true));
                        } else {
                            locationsSelect.append($('<option />').val(location.ID).text(locationText));
                        }
                    });
                });

                validationPlaceHolder.removeClass('alert-danger');
                validationPlaceHolder.addClass('alert-success');
                validationPlaceHolder.html('<div>New location has been added successfully!</div>');
            } else {
                validationPlaceHolder.html('<div>Failed to add the new location</div>');
            }

            iris.unsetButtonLoading($('#company-add-location'));
            validationPlaceHolder.show();

            $('.add_location').modal('hide');
            $('.modal-backdrop').remove();
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#company-add-location'));
            profile.handleAjaxErrorResponse(response, status, error, undefined, '#dialog-ajax-validation');
        }
    });
});

$('body').on('click', '#api-add-key', function () {
    var omnitrackerId = $(this).data('ot-id');

    iris.setButtonLoading($('#api-add-key'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'POST',
        url: '/profile/apis/keys/create',
        data: $('form#addApiKey').serialize(),
        success: function (response) {
            var validationPlaceHolder = $('#ajax-validation');

            if (response.success) {
                $('#apis').html(response.view);
                validationPlaceHolder.removeClass('alert-danger');
                validationPlaceHolder.addClass('alert-success');
            } else {
                validationPlaceHolder.removeClass('alert-success');
                validationPlaceHolder.addClass('alert-danger');
            }

            validationPlaceHolder.html('<div>' + response.message + '</div>');
            validationPlaceHolder.show();

            $('.add_api_key').modal('hide');
            iris.unsetButtonLoading($('#api-add-key'));
            $('form#addApiKey').trigger("reset");
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#api-add-key'));
            profile.handleAjaxErrorResponse(response, status, error, undefined, '#apikey-dialog-ajax-validation');
        }
    });
});

$('body').on('click', '#button-request-cloudstore-poc', function () {
    iris.setButtonLoading($('#button-request-cloudstore-poc'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'GET',
        url: '/profile/apis/request-cloudstore-poc',
        success: function (response) {
            var validationPlaceHolder = $('#ajax-validation');

            if (response.success) {
                $('#apis').html(response.view);
                validationPlaceHolder.removeClass('alert-danger');
                validationPlaceHolder.addClass('alert-success');
            } else {
                validationPlaceHolder.removeClass('alert-success');
                validationPlaceHolder.addClass('alert-danger');
            }

            validationPlaceHolder.html('<div>' + response.message + '</div>');
            validationPlaceHolder.show();

            iris.unsetButtonLoading($('#button-request-cloudstore-poc'));
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#button-request-cloudstore-poc'));
            profile.handleAjaxErrorResponse(response, status, error, 'Could not send POC request');
        }
    });
});

$('body').on('click', '#button-notifications-save-changes', function () {
    iris.setButtonLoading($('#button-notifications-save-changes'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'POST',
        data: $('form#form-update-profile-notifications').serialize(),
        url: '/profile/companies/statuspage/subscribers',
        success: function (response) {
            var validationPlaceHolder = $('#ajax-validation');

            if (response.success) {
                $('#tab-company-notifications').html(response.view);
                validationPlaceHolder.removeClass('alert-danger');
                validationPlaceHolder.addClass('alert-success');
            } else {
                validationPlaceHolder.removeClass('alert-success');
                validationPlaceHolder.addClass('alert-danger');
            }

            validationPlaceHolder.html('<div>' + response.message + '</div>');
            validationPlaceHolder.show();

            iris.unsetButtonLoading($('#button-notifications-save-changes'));
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#button-notifications-save-changes'));
            profile.handleAjaxErrorResponse(response, status, error, 'Could not register a subscriber');
        }
    });
});

$('body').on('change', 'form#addApiKey #api', function () {
    var apiCloudstore = 'CLOUDSTORE';
    var keyTypeDev = 'Development';
    var keyTypeProd = 'Production';
    var keyTypeDropdown = $("form#addApiKey #keyType");

    if (this.value === apiCloudstore) {
        // if cloudstore is selected, key type "production" should not be available, as we don't allow production keys to be generated for the cloudstore
        keyTypeDropdown.empty();
        keyTypeDropdown.append($("<option />").val(keyTypeDev).text(keyTypeDev));
    } else {
        // if key type other than cloudstore is selected, key type "production" should be available
        keyTypeDropdown.empty();
        keyTypeDropdown.append($("<option />").val(keyTypeDev).text(keyTypeDev));
        keyTypeDropdown.append($("<option />").val(keyTypeProd).text(keyTypeProd));
    }
});

$('body').on('click', '#remove_api_key', function () {
    var keyId = $(this).data('key-id');

    profile.clearValidationFeedback();

    $.ajax({
        method: 'GET',
        url: '/profile/apis/keys/' + keyId + '/delete',
        success: function (response) {
            var validationPlaceHolder = $('#ajax-validation');

            if (response.success) {
                $('#apis').html(response.view);
                validationPlaceHolder.removeClass('alert-danger');
                validationPlaceHolder.addClass('alert-success');
            } else {
                validationPlaceHolder.removeClass('alert-success');
                validationPlaceHolder.addClass('alert-danger');
            }

            validationPlaceHolder.html('<div>' + response.message + '</div>');
            validationPlaceHolder.show();
        },
        error: function (response, status, error) {
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

$('body').on('click', '#update_api_key', function () {
    var keyId = $(this).data('key-id');
    var ipAddress = $('#' + keyId + '-ip').val();

    profile.clearValidationFeedback();

    $.ajax({
        method: 'POST',
        url: '/profile/apis/keys/' + keyId + '/update',
        data: {
            keyId: keyId,
            ipAddress: ipAddress
        },
        success: function (response) {
            var validationPlaceHolder = $('#ajax-validation');

            iris.unsetButtonLoading($('#update_api_key'));

            if (response.success === true) {
                $('#apis').html(response.view);
                validationPlaceHolder.removeClass('alert-danger');
                validationPlaceHolder.addClass('alert-success');
            } else {
                validationPlaceHolder.removeClass('alert-success');
                validationPlaceHolder.addClass('alert-danger');
            }

            validationPlaceHolder.html('<div>' + response.message + '</div>');
            validationPlaceHolder.show();
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#update_api_key'));
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

$('body').on('click', '.endpoints .nav-link', function () {
    var arrowSpan = $(this).find('.fa');

    if (arrowSpan.hasClass('fa-angle-double-down')) {
        arrowSpan.removeClass('fa-angle-double-down');
        arrowSpan.addClass('fa-angle-double-up');
    } else if (arrowSpan.hasClass('fa-angle-double-up')) {
        arrowSpan.removeClass('fa-angle-double-up');
        arrowSpan.addClass('fa-angle-double-down');
    }
});

$('body').on('click', '#reset-password', function () {
    var resetSuccessMessage = 'Success! We have sent you an e-mail with password reset instructions';
    var resetFailedMessage = 'Your reset password request could not be completed';
    $('#reset-password').removeClass('btn-outline-primary');
    $('#reset-password').addClass('btn-primary');
    profile.clearValidationFeedback();
    iris.setButtonLoading($('#reset-password'));

    $.ajax({
        method: 'POST',
        url: 'password/email',
        data: {email: $('form#contact-details #cd_username').val()},
        success: function (response) {
            if (JSON.parse(response) === 'passwords.sent') {
                $('#reset-password-div').html('<div class="btn btn-block btn-outline-primary" style="pointer-events:none">E-mail sent!</div>');
                $('#ajax-validation').removeClass('alert-danger');
                $('#ajax-validation').addClass('alert-success');
                $('#ajax-validation').html('<div>' + resetSuccessMessage + '</div>');
                $('#ajax-validation').show();
            } else {
                $('#ajax-validation').html('<div>' + resetFailedMessage + '</div>');
                $('#ajax-validation').show();
                iris.unsetButtonLoading($('#reset-password'));
                $('#reset-password').addClass('btn-outline-primary');
                $('#reset-password').removeClass('btn-primary');
            }
        },
        error: function (response, status, error) {
            iris.logAndAlert(response, status, error, resetFailedMessage);
            iris.unsetButtonLoading($('#reset-password'));
            $('#reset-password').addClass('btn-outline-primary');
            $('#reset-password').removeClass('btn-primary');
        }
    });
});

$('body').on('click', '.you-contact-details-save-changes', function () {
    var omnitrackerId = $(this).data('ot-id');

    iris.setButtonLoading($('.you-contact-details-save-changes'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'PUT',
        url: '/profile/employees/' + omnitrackerId + '/contact-details',
        data: $('form#contact-details').has('input[name=omnitrackerId][value=' + omnitrackerId + ']').serialize(),
        success: function (response) {
            $('#tab-you-contact-details-' + omnitrackerId).html(response);
            iris.unsetButtonLoading($('.you-contact-details-save-changes'));
        },
        error: function (response, status, error) {
            profile.handleAjaxErrorResponse(response, status, error);
            iris.unsetButtonLoading($('.you-contact-details-save-changes'));
        }
    });
});

$('body').on('click', '.you-merge-accounts', function () {
    var omnitrackerId = $(this).data('ot-id');
    profile.clearValidationFeedback();

    $.ajax({
        method: 'POST',
        url: '/profile/employees/' + omnitrackerId + '/merge-accounts',
        data: $('form#merge-accounts').serialize(),
        success: function (response) {
            $('#tab-you-manage-account-' + omnitrackerId).html(response);
        },
        error: function (response, status, error) {
            profile.handleAjaxErrorResponse(response, status, error);
            iris.unsetButtonLoading($('.you-merge-accounts'));
        }
    });
});

$('body').on('click', '.merge-accounts-disable-reminder', function () {
    var omnitrackerId = $(this).data('ot-id');
    profile.clearValidationFeedback();

    $.ajax({
        method: 'GET',
        url: '/profile/employees/' + omnitrackerId + '/merge-accounts-disable-reminder',
        success: function (response) {
            $('#tab-you-manage-account-' + omnitrackerId).html(response);
        },
        error: function (response, status, error) {
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

$('body').on('click', '.you-preferences-save-changes', function () {
    var omnitrackerId = $(this).data('ot-id');

    iris.setButtonLoading($('.you-preferences-save-changes'));
    profile.clearValidationFeedback();

    var formData = $('form#preferences').serializeArray();
    $('.preference').each(function () {
        formData.push({name: $(this).data('preference-id'), value: $(this).prop('checked') === true});
    });

    $.ajax({
        method: 'PUT',
        url: '/profile/employees/' + omnitrackerId + '/preferences',
        data: formData,
        success: function (response) {
            $('#tab-you-preferences-' + omnitrackerId).html(response);
            iris.unsetButtonLoading($('.you-preferences-save-changes'));
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('.you-preferences-save-changes'));
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

$('body').on('click', '.you-update-status', function () {
    var omnitrackerId = $(this).data('ot-id');

    iris.setButtonLoading($('.you-update-status'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'PUT',
        url: '/profile/employees/' + omnitrackerId + '/status',
        data: $('form#status').has('input[name=omnitrackerId][value=' + omnitrackerId + ']').serialize(),
        success: function (response) {
            $('#tab-you-status-' + omnitrackerId).html(response);
            iris.unsetButtonLoading($('.you-update-status'));
            profile.loadEmployeesOverview();
        },
        error: function (response, status, error) {
            profile.handleAjaxErrorResponse(response, status, error);
            iris.unsetButtonLoading($('.you-update-status'));
        }
    });
});

$('body').on('click', '#you-delete-user', function () {
    var omnitrackerId = $(this).data('ot-id');

    iris.setButtonLoading($('#you-delete-user'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'PUT',
        url: '/profile/employees/' + omnitrackerId + '/delete',
        data: $('form#status').has('input[name=omnitrackerId][value=' + omnitrackerId + ']').serialize(),
        success: function (response) {
            $('#tab-you-status-' + omnitrackerId).html(response);
            iris.unsetButtonLoading($('#you-delete-user'));
            profile.loadEmployeesOverview();
        },
        error: function (response, status, error) {
            profile.handleAjaxErrorResponse(response, status, error);
            iris.unsetButtonLoading($('#you-delete-user'));
        }
    });
});

$('body').on('click', '.you-update-roles', function () {
    var omnitrackerId = $(this).data('ot-id');

    iris.setButtonLoading($('.you-update-roles'));
    profile.clearValidationFeedback();

    $.ajax({
        method: 'PUT',
        url: '/profile/employees/' + omnitrackerId + '/roles',
        data: $('form#roles-and-permissions').has('input[name=omnitrackerId][value=' + omnitrackerId + ']').serialize(),
        success: function (response) {
            $('#tab-you-roles-permissions-' + omnitrackerId).html(response);
            iris.unsetButtonLoading($('.you-update-roles'));
            profile.loadEmployeesOverview();
        },
        error: function (response, status, error) {
            profile.handleAjaxErrorResponse(response, status, error);
            iris.unsetButtonLoading($('.you-update-roles'));
        }
    });
});

$('body').on('click', '#limited-branding-save', function () {
    iris.setButtonLoading($('#limited-branding-save'));
    profile.clearValidationFeedback();

    var formData = new FormData();
    formData.append('invoiceLogo', $('#invoiceLogo')[0].files[0] || '');

    $.ajax({
        method: 'POST',
        url: '/profile/brand/upsertInvoiceLogo',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
            var validationPlaceHolder = $('#ajax-validation');
            iris.unsetButtonLoading($('#limited-branding-save'));

            if (response.success === true) {
                validationPlaceHolder.removeClass('alert-danger');
                validationPlaceHolder.addClass('alert-success');
            } else {
                validationPlaceHolder.removeClass('alert-success');
                validationPlaceHolder.addClass('alert-danger');
            }

            validationPlaceHolder.html('<div>' + response.message + '</div>');
            validationPlaceHolder.show();
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('.limited-branding-save'));
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

// full branding profile
$('body').on('click', '#branding-save-changes', function () {
    iris.setButtonLoading($('#branding-save-changes'));
    profile.clearValidationFeedback();

    var formData = new FormData();
    var fields = $('form#update-profile-branding').serializeArray();
    $.each(fields, function (i, field) {
        formData.append(field.name, field.value);
    });

    formData.append('whitelogo', $('#whitelogo')[0].files[0] || '');
    formData.append('blacklogo', $('#blacklogo')[0].files[0] || '');
    formData.append('colorlogo', $('#colorlogo')[0].files[0] || '');
    formData.append('removedLogos', iris.removedLogos);

    $.ajax({
        method: 'POST',
        url: '/profile/brand/upsert',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
            $('#tab-company-branding').html(response);
        },
        error: function (response, status, error) {
            iris.unsetButtonLoading($('#branding-save-changes'));
            profile.handleAjaxErrorResponse(response, status, error);
        }
    });
});

// roles & permissions
$('body').on('change', '.baseRole', function () {

    var omnitrackerId = $(this).data('ot-id');
    var baseRoleId = $(this).val();
    var moduleRoles = $('#moduleRoles-' + omnitrackerId);

    $('.you-update-roles').prop('disabled', true);
    $('#ms-moduleRoles-' + omnitrackerId).addClass('loading-multi-select');
    moduleRoles.prop('disabled', true);
    moduleRoles.multiSelect('refresh');

    if (!$.isNumeric(baseRoleId)) {
        return;
    }

    $.ajax({
        method: 'GET',
        url: '/profile/employees/' + omnitrackerId + '/module-roles/' + baseRoleId,
        success: function (moduleRolesStatus) {
            moduleRoles.removeAttr('disabled');

            $.each(moduleRolesStatus, function (roleId, roleStatus) {
                if (roleStatus.selected) {
                    $('#moduleRoles-' + omnitrackerId + ' option[value=' + roleId + ']').prop('selected', true);
                } else {
                    $('#moduleRoles-' + omnitrackerId + ' option[value=' + roleId + ']').prop('selected', false);
                }

                if (roleStatus.disabled) {
                    $('#moduleRoles-' + omnitrackerId + ' option[value=' + roleId + ']').prop('disabled', true);
                } else {
                    $('#moduleRoles-' + omnitrackerId + ' option[value=' + roleId + ']').prop('disabled', false);
                }
            });

            moduleRoles.multiSelect('refresh');
            $('.you-update-roles').prop('disabled', false);
        },
        error: function (response, status, error) {
            console.log("AJAX error: " + status + " (" + response.status + ") : " + error);

            moduleRoles.removeAttr('disabled');
            moduleRoles.multiSelect('refresh');
            $('.you-update-roles').prop('disabled', false);

            if (response.status === 403) {
                // error 403 will be returned on authorize failure
                iris.logAndAlert(response, status, error, 'You do not have sufficient permissions to perform this action');
            } else {
                iris.logAndAlert(response, status, error, 'Could not retrieve module roles status (status ' + status + ')');
            }
        }
    });
});

$('body').on('click', '.employee', function () {
    var omnitrackerId = $(this).data('ot-id');
    var authenticatedUserOtId = $(this).data('auth-ot-id');
    var loadingHtml = '<td colspan="5" class="employeeLoading">&nbsp;</td>';
    var employeeTableRow = $(this);
    var employeeTableRowHtml = employeeTableRow.html() != loadingHtml ? employeeTableRow.html() : employeeTableRowHtml;

    employeeTableRow.html(loadingHtml);

    if (omnitrackerId == authenticatedUserOtId) {
        window.location.href = '/profile/tab/you/contact-details';
        return;
    }

    $.ajax({
        method: 'GET',
        employeeTableRowHtml: employeeTableRowHtml,
        employeeTableRow: employeeTableRow,
        url: '/profile/employees/' + omnitrackerId + '/subtab/contact-details',
        success: function (response) {
            // replace content of the company-user tab
            $('#company-user').html(response.view);

            // init moduleRoles multiSelect
            $('.moduleRoles').multiSelect({
                selectableHeader: '<div class="selectableHeader">Unassigned Roles</div>',
                selectionHeader: '<div class="selectionHeader">Assigned Roles</div>'
            });

            $('.nav-tabs #user').html('<i class="fa fa-fw fa-user"></i> ' + response.tabName);
            $('.nav-tabs #user').trigger('click');

            $('#company-user-nav-item').css('visibility', 'visible');

            employeeTableRow.html(employeeTableRowHtml);
        },
        error: function (response, status, error) {
            employeeTableRow.html(employeeTableRowHtml);
            console.log(error);
        }
    });
});

// Your API events

$('body').on('change', '#billingApi .acceptHeader', function () {
    profile.generateInvoicesUrl($(this).data('id'));
});


$('body').on('change', '#billingApi .subscriptionId', function () {
    var subscriptionId = this.value;
    if (subscriptionId == null) {
        this.value = '';
    } else {
        $('input[class*=subscriptionId][data-id=' + $(this).data('id') + ']').val(subscriptionId);
        profile.generateInvoicesUrl($(this).data('id'));
    }
});

$('body').on('change', '#billingApi .subscriptionIds', function () {
    var subscriptionIds = this.value;
    if (subscriptionIds == null) {
        this.value = '';
    } else {
        $('input[class*=subscriptionIds][data-id=' + $(this).data('id') + ']').val(subscriptionIds);
        profile.generateInvoicesUrl($(this).data('id'));
    }
});

$('body').on('change', '#billingApi .startDate', function () {
    var startDate = iris.getDate(this);
    if (startDate == null) {
        this.value = '';
    } else {
        $('input[class*=endDate][data-id=' + $(this).data('id') + ']').datepicker("option", "minDate", startDate);
        profile.generateInvoicesUrl($(this).data('id'));
    }
});

$('body').on('change', '#billingApi .endDate', function () {
    var endDate = iris.getDate(this);
    if (endDate == null) {
        this.value = '';
    } else {
        profile.generateInvoicesUrl($(this).data('id'));
    }
});

$('body').on('change', '#billingApi .acceptHeader', function () {
    profile.generateInvoicesUrl($(this).data('id'));
});

$('body').on('change', '#billingApi .apiVersion', function () {
    var keyId = $(this).data('id');
    var endpointSlugs = $.parseJSON($('input[class*=keyEndpoints][data-id=' + keyId + ']').val());

    $.each(endpointSlugs, function (index, endpointSlug) {
        profile.generateInvoicesUrl(keyId + '-' + endpointSlug);
    });
});

$('body').on('click', '#billingApi .yourUrl', function (event) {
    event.preventDefault();

    var keySlugId = $(this).data('id');
    var keyId = keySlugId.split('-')[0];
    var endpointSlug = keySlugId.split('-')[1];
    var startDate = moment($('input[class*=startDate][data-id=' + keySlugId + ']').datepicker('getDate'));
    var endDate = moment($('input[class*=endDate][data-id=' + keySlugId + ']').datepicker('getDate'));
    var subscriptionId = $('input[class*=subscriptionId][data-id=' + keySlugId + ']').val();
    var subscriptionIds = $('input[class*=subscriptionIds][data-id=' + keySlugId + ']').val();
    var endpoint = $('input[class*=endpointUrl][data-id=' + keySlugId + ']').val();
    var apiVersion = $('select[class*=apiVersion][data-id=' + keyId + ']').val();
    var authHeader = $('input[class*=authHeader][data-id=' + keySlugId + ']').val();
    var acceptHeader = $('select[class*=acceptHeader][data-id=' + keySlugId + ']').val();
    var workingEndpoint = (apiVersion !== '') ? endpoint.replace('{version}', apiVersion) : endpoint;

    if (!startDate.isValid() || !endDate.isValid()) {
        alert('You need to set a Start and End Date');
    } else if (apiVersion === '') {
        alert('You need to select an API Version');
    } else if (endpointSlug === "subscriptiondetails" && subscriptionId === '') {
        alert('You need to fill in the Subscription Id');
    } else if (endpointSlug === "subscriptionsdetails" && subscriptionIds === '') {
        alert('You need to fill in the Subscription IDs, seperated by a comma');
    } else {
        var callBillingApiUrl = '/profile/apis/callBillingApi';
        if (endpointSlug !== "subscriptiondetails" && endpointSlug !== "subscriptionsdetails") {
            callBillingApiUrl += '?startDate=' + startDate.format('YYYYMMDD');
            callBillingApiUrl += '&endDate=' + endDate.format('YYYYMMDD');
        }
        if(endpointSlug === "subscriptiondetails")
        {
            callBillingApiUrl += '?subscriptionId=' + subscriptionId;
        }
        if(endpointSlug === "subscriptionsdetails")
        {
            callBillingApiUrl += '?subscriptionIds=' + subscriptionIds;
        }
        callBillingApiUrl += '&endpoint=' + encodeURIComponent(workingEndpoint);
        callBillingApiUrl += '&acceptHeader=' + encodeURIComponent(acceptHeader);
        callBillingApiUrl += '&authHeader=' + encodeURIComponent(authHeader);
        callBillingApiUrl += '&fileName=' + encodeURIComponent(endpointSlug);
        callBillingApiUrl += acceptHeader === 'application/json' ? '.json' : '.xml';

        location.href = callBillingApiUrl;
    }
});

$('body').on('change', '#cloudstoreApi .apiVersion', function () {
    var keyId = $(this).data('id');
    var endpointSlugs = $.parseJSON($('input[class*=keyEndpoints][data-id=' + keyId + ']').val());

    $.each(endpointSlugs, function (index, endpointSlug) {
        profile.generateCloudstoreUrl(keyId + '-' + endpointSlug);
    });
});

$('body').on('change', '#customersApi .acceptHeader', function () {
    profile.generateCustomersUrl($(this).data('id'));
});

$('body').on('change', '#customersApi .apiVersion', function () {
    var keyId = $(this).data('id');
    var endpointSlugs = $.parseJSON($('input[class*=keyEndpoints][data-id=' + keyId + ']').val());

    $.each(endpointSlugs, function (index, endpointSlug) {
        profile.generateCustomersUrl(keyId + '-' + endpointSlug);
    });
});

$('body').on('click', '#customersApi .yourUrl', function (event) {
    event.preventDefault();
    var keySlugId = $(this).data('id');
    var keyId = keySlugId.split('-')[0];
    var endpointSlug = keySlugId.split('-')[1];
    var endpoint = $('input[class*=endpointUrl][data-id=' + keySlugId + ']').val();
    var apiVersion = $('select[class*=apiVersion][data-id=' + keyId + ']').val();
    var authHeader = $('input[class*=authHeader][data-id=' + keySlugId + ']').val();
    var acceptHeader = $('select[class*=acceptHeader][data-id=' + keySlugId + ']').val();
    var workingEndpoint = (apiVersion !== '') ? endpoint.replace('{version}', apiVersion) : endpoint;

    if (apiVersion === '') {
        alert('You need to select an API Version');
    } else {
        var callCustomersApiUrl = '/profile/apis/callCustomersApi';
        callCustomersApiUrl += '?endpoint=' + encodeURIComponent(workingEndpoint);
        callCustomersApiUrl += '&acceptHeader=' + encodeURIComponent(acceptHeader);
        callCustomersApiUrl += '&authHeader=' + encodeURIComponent(authHeader);
        callCustomersApiUrl += '&fileName=customers';
        callCustomersApiUrl += acceptHeader === 'application/json' ? '.json' : '.xml';

        location.href = callCustomersApiUrl;
    }
});


/*******************
 * Profile methods *
 *******************/

// define 'profile' namespace
if (!('profile' in window)) window['profile'] = {};

profile.generateInvoicesUrl = function(keySlugId) {
    var startDate = moment($('input[class*=startDate][data-id=' + keySlugId + ']').datepicker('getDate'));
    var endDate = moment($('input[class*=endDate][data-id=' + keySlugId + ']').datepicker('getDate'));
    var subscriptionId = $('input[class*=subscriptionId][data-id=' + keySlugId + ']').val();
    var subscriptionIds = $('input[class*=subscriptionIds][data-id=' + keySlugId + ']').val();

    var keyId = keySlugId.split('-')[0];
    var endpointSlug = keySlugId.split('-')[1];
    var endpoint = $('input[class*=endpointUrl][data-id=' + keySlugId + ']').val();
    var apiVersion = $('select[class*=apiVersion][data-id=' + keyId + ']').val();
    var acceptHeader = $('select[class*=acceptHeader][data-id=' + keySlugId + ']').val();
    var workingDomain = $('input[class*=keyDomain][data-id=' + keyId + ']').val();
    var workingEndpoint = (apiVersion !== '') ? endpoint.replace('{version}', apiVersion) : endpoint;
    var workingUrl =  'https://' + workingDomain + workingEndpoint;


    if (endpointSlug === "subscriptiondetails") {
        workingUrl += '?subscriptionId=' + subscriptionId;
    } else if (endpointSlug === "subscriptionsdetails") {
        workingUrl += '?subscriptionIds=' + subscriptionIds;
    } else {
        if (startDate.isValid() && endDate.isValid()) {
            workingUrl += '?startDate=' + startDate.format('YYYYMMDD');
            workingUrl += '&endDate=' + endDate.format('YYYYMMDD');
        }
    }


    $('a[class*=yourUrl][data-id=' + keySlugId + ']').html(workingUrl);
    $('a[class*=yourUrl][data-id=' + keySlugId + ']').attr('href', workingUrl);
    $('span[class*=endpoint][data-id=' + keySlugId + ']').html(workingEndpoint);

    $('span[data-id=format-' + keySlugId + ']').html(acceptHeader === 'application/json' ? 'JSON' : 'XML');
    $('span[data-id=otherFormat-' + keySlugId + ']').html(acceptHeader === 'application/json' ? 'XML' : 'JSON');
}

profile.generateCloudstoreUrl = function(keySlugId) {
    var keyId = keySlugId.split('-')[0];
    var endpointSlug = keySlugId.split('-')[1];
    var endpoint = $('input[class*=endpointUrl][data-id=' + keySlugId + ']').val();
    var apiVersion = $('select[class*=apiVersion][data-id=' + keyId + ']').val();
    var workingEndpoint = (apiVersion !== '') ? endpoint.replace('{version}', apiVersion) : endpoint;

    $('span[class*=endpoint][data-id=' + keySlugId + ']').html(workingEndpoint);
}

profile.generateCustomersUrl = function(keySlugId) {
    var keyId = keySlugId.split('-')[0];
    var endpointSlug = keySlugId.split('-')[1];
    var endpoint = $('input[class*=endpointUrl][data-id=' + keySlugId + ']').val();
    var apiVersion = $('select[class*=apiVersion][data-id=' + keyId + ']').val();
    var acceptHeader = $('select[class*=acceptHeader][data-id=' + keySlugId + ']').val();
    var workingDomain = $('input[class*=keyDomain][data-id=' + keyId + ']').val();
    var workingEndpoint = (apiVersion !== '') ? endpoint.replace('{version}', apiVersion) : endpoint;
    var workingUrl =  'https://' + workingDomain + workingEndpoint;

    $('a[class*=yourUrl][data-id=' + keySlugId + ']').html(workingUrl);
    $('a[class*=yourUrl][data-id=' + keySlugId + ']').attr('href', workingUrl);
    $('span[class*=endpoint][data-id=' + keySlugId + ']').html(workingEndpoint);

    $('span[data-id=format-' + keySlugId + ']').html(acceptHeader === 'application/json' ? 'JSON' : 'XML');
    $('span[data-id=otherFormat-' + keySlugId + ']').html(acceptHeader === 'application/json' ? 'XML' : 'JSON');
}

profile.generateInvoicesUrls = function () {
    let keys = $('#billingApi .keys').html();

    if (typeof keys !== 'undefined') {
        let keysJson = $.parseJSON(keys);

        $.each(keysJson, function (i, key) {
            $.each(key.Endpoints, function (endpointSlug, endpoint) {
                let sectionId = key.ID + '-' + endpointSlug;
                profile.generateInvoicesUrl(sectionId);
            })
        })
    }
}

profile.generateCustomersUrls = function () {
    let keys = $('#customersApi .keys').html();

    if (typeof keys !== 'undefined') {
        var keysJson = $.parseJSON(keys);

        $.each(keysJson, function (i, key) {
            $.each(key.Endpoints, function (endpointSlug, endpoint) {
                var sectionId = key.ID + '-' + endpointSlug;
                profile.generateCustomersUrl(sectionId);
            })
        })
    }
}

profile.updateUsernameSuggestion = function() {
    var firstnameInputValue = $('#add-employee-first-name').val();
    var lastnameInputValue = $('#add-employee-last-name').val();
    var usernameInput = $('#add-employee-username');

    if (!iris.usernameChangedManually && firstnameInputValue !== '' && lastnameInputValue !== '') {
        var initialSuggestion = firstnameInputValue.replace(/\s/g, '').toLowerCase().charAt(0);
        var lastnameSuggestion = lastnameInputValue.replace(/\s/g, '').toLowerCase();

        usernameInput.val(initialSuggestion + lastnameSuggestion);
    }
}

profile.clearValidationFeedback = function() {
    $('div#validation').remove();
    $('#ajax-validation').empty().hide();
    $('#dialog-ajax-validation').empty().hide();
    $('#apikey-dialog-ajax-validation').empty().hide();
    $('#download-invoice-dialog-ajax-validation').empty().hide();
    $('div').find("[data-field]").removeClass('has-danger');
}

profile.loadEmployeesOverview = function() {
    $.ajax({
        method: 'GET',
        url: '/profile/employees',
        success: function (response) {
            $('#tab-company-users').html(response);
        },
        error: function (response, status, error) {
            console.log(error);
        }
    });
}

profile.handleAjaxErrorResponse = function(response, status, error, message, divId = '#ajax-validation') {
    console.log("AJAX error: " + status + " (" + response.status + ") : " + error);

    if (response.status === 422) {
        // error 422 will be returned on validation failure!
        let jsonResponse = $.parseJSON(response.responseText);
        $('#validation').empty();
        if (jsonResponse != null && jsonResponse.errors != null) {
            $.each(jsonResponse.errors, function (key, values) {
                $.each(values, function (index, value) {
                    $('div').find("[data-field='" + key + "']").addClass('has-danger');
                    $(divId).removeClass('alert-success');
                    $(divId).addClass('alert-danger');
                    $(divId).append('<div>' + value + '</div>');
                });

                $(divId).show();
            });
        } else {
            $(divId).removeClass('alert-success');
            $(divId).addClass('alert-danger');
            $(divId).append('<div>Validation failed, check your input</div>');
            $(divId).show();
        }
    } else if (response.status === 403) {
        // error 403 will be returned on authorize failure
        iris.logAndAlert(response, status, error, 'You do not have sufficient permissions to perform this action');
    } else if (response.status === 302) {
        // error 302 will be returned on redirect response
        window.location.href = jsonResponse.redirectTo;
    } else {
        if (response.responseText != null && response.responseText !== '') {
            message = response.responseText;
        }

        iris.logAndAlert(response, status, error, message, divId);
    }
}